import * as React from "react";
import ListAltIcon from "@material-ui/icons/ListAlt";

export const BeperkingTypesIcon = () => {
    return <ListAltIcon />;
}

